import { render, staticRenderFns } from "./WorkloadDetailReleaseName.vue?vue&type=template&id=8f820714"
import script from "./WorkloadDetailReleaseName.vue?vue&type=script&lang=js"
export * from "./WorkloadDetailReleaseName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports